import { Modal } from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
    .ant-result {
        padding: 20px 16px;
    }
    
    .ant-result-icon {
        display: flex;
        justify-content: center;
    }

    .margin-vertical-negative-24 {
        margin: -24px 0;
    }

`;
